export type ThreadSort =
  | "latest-thread"
  | "oldest-thread"
  | "latest-reply"
  | "most-upvotes";

export const DEFAULT_PROJECTOR_BOARD_SORT = "most_liked" as const;

export interface SortableThread {
  id: string;
  createdAt: number;
  lastActivityAt: number;
  replyCount: number;
  threadLikeCount: number;
}

function compareIds(a: SortableThread, b: SortableThread): number {
  return a.id.localeCompare(b.id);
}

export function compareOldestThreads(a: SortableThread, b: SortableThread): number {
  return a.createdAt - b.createdAt || compareIds(a, b);
}

export function compareNewestThreads(a: SortableThread, b: SortableThread): number {
  return b.createdAt - a.createdAt || compareIds(a, b);
}

export function compareLatestActivity(a: SortableThread, b: SortableThread): number {
  return b.lastActivityAt - a.lastActivityAt
    || b.createdAt - a.createdAt
    || compareIds(a, b);
}

export function compareMostReplies(a: SortableThread, b: SortableThread): number {
  return b.replyCount - a.replyCount || compareOldestThreads(a, b);
}

export function compareMostUpvotes(a: SortableThread, b: SortableThread): number {
  return b.threadLikeCount - a.threadLikeCount
    || b.replyCount - a.replyCount
    || compareOldestThreads(a, b);
}

export function compareThreads(
  a: SortableThread,
  b: SortableThread,
  sort: ThreadSort,
): number {
  if (sort === "oldest-thread") return compareOldestThreads(a, b);
  if (sort === "latest-reply") return compareLatestActivity(a, b);
  if (sort === "most-upvotes") return compareMostUpvotes(a, b);
  return compareNewestThreads(a, b);
}
